import { render, staticRenderFns } from "./dept-add-or-update.vue?vue&type=template&id=1dc798d2&"
import script from "./dept-add-or-update.vue?vue&type=script&lang=js&"
export * from "./dept-add-or-update.vue?vue&type=script&lang=js&"
import style0 from "./dept-add-or-update.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports